module.exports = __webpack_public_path__ + "static/media/adv_img_3.d5b5b661.jpg";